import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import NewsletterSection from './components/NewsletterSection';
import SeoHead from '@/components/base/SeoHead';

export default function Home() {
  return (
    <>
      <SeoHead
        title="第一次的人妻——新婚妻子角色转变全攻略 | 初为人妻适应指南"
        description="第一次的人妻，面对婚后全新生活充满迷茫？本页为初为人妻的女性提供角色适应、家庭经营、夫妻沟通与自我成长的实用指南，帮助每一位第一次的人妻从容迈入婚姻新阶段。"
        keywords="第一次的人妻,初为人妻适应指南,新婚生活经营技巧,人妻角色转变,婚后自我成长,夫妻沟通方法,新婚女性必读"
        canonicalUrl="/"
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <NewsletterSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '第一次的人妻——新婚妻子角色转变全攻略',
            description: '为初为人妻的女性提供角色适应、家庭经营、夫妻沟通与自我成长的实用指南',
            url: 'https://diyiciderenqi.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '第一次的人妻',
              url: 'https://diyiciderenqi.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://diyiciderenqi.com/' },
              ],
            },
          }),
        }}
      />
    </>
  );
}